import { endPoints, getDashboardOrchestrationServiceEndPoint } from "./base-url/api-constants";
import { apiService } from "./base-api-service/base-api-service";
import { readCookie } from "../Util/helper";

class DocOrchestrationService {
  DocOrchestrationService(url: any) {
    return getDashboardOrchestrationServiceEndPoint(url);
  }
  
    GenerateSasUriTokenForContainer(hoursExpiry:any) {
    const jwtToken = readCookie("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const sasTokenEndPoint = endPoints.dashboardOrchestrationService.SAS_TOKEN;
    const getServiceEndpoint = this.DocOrchestrationService(`${sasTokenEndPoint.replace(":expiryHours", hoursExpiry)}`);
    return apiService.get(getServiceEndpoint, null, headers);
  }
}

export default new DocOrchestrationService();
